import React, { useState } from "react";

import { AnalyticsStrings } from "constants/constantStrings";

import BadgeLabel from "components/BadgeLabel";
import DupontIconButton from "components/DupontIconButton";

import BarPlotIcon from "assets/SvgIcon/BarPlotIcon";
import ListViewIcon from "assets/SvgIcon/ListViewIcon";
import ScatterPlotIcon from "assets/SvgIcon/ScatterPlotIcon";

import { CIP_INDEX_GRAPH_TYPE_DEFAULT, CIPCleaningViews } from "../AnalyticsHelper/Analytics.const";

const CIPCleaningHeader = ({ onViewChange, isCIPEvents }) => {
  const [activePlotView, setActivePlotView] = useState(CIP_INDEX_GRAPH_TYPE_DEFAULT);

  const viewChangeHandler = event => {
    onViewChange(event.currentTarget?.name);
    setActivePlotView(event.currentTarget?.name);
  };

  return (
    <div className="cip-cleaning--header">
      <BadgeLabel badgeDescription={AnalyticsStrings.CIP_TIME_CLEANING} />

      {isCIPEvents && (
        <div className="d-flex cip-cleaning--chart-type">
          <DupontIconButton name="markers" tooltip={CIPCleaningViews.markers} onClick={viewChangeHandler}>
            <ScatterPlotIcon isActive={activePlotView === "markers"} />
          </DupontIconButton>
          <DupontIconButton name="bar" tooltip={CIPCleaningViews.bar} onClick={viewChangeHandler}>
            <BarPlotIcon isActive={activePlotView === "bar"} />
          </DupontIconButton>
          <DupontIconButton name="table" tooltip={CIPCleaningViews.table} onClick={viewChangeHandler}>
            <ListViewIcon isActive={activePlotView === "table"} />
          </DupontIconButton>
        </div>
      )}
    </div>
  );
};

export default CIPCleaningHeader;
